module.exports = __webpack_public_path__ + "assets/success-160122.svg";